
interface IProps {
    children?: any,
}

export const SourcesTable = (props: IProps) => {

    return (
        <div className="table-responsive table-dropdown">
            <table className="table table-centered">
                <thead className="thead-light">
                    <tr>
                        <th>Název</th>

                        <th>Stav</th>

                        <th>Zdroj dat</th>

                        <th>Importováno</th>

                        <th>Poslední import</th>

                        <th></th>
                    </tr>
                </thead>

                <tbody>
                    {props.children}
                </tbody>
            </table>
        </div>)
}